/**
 * Interface de los documentos generados
 *
 * @export
 * @interface DocumentoGenerado
 */
export interface DocumentoGenerado {
  clasificacion_id: number;
  idtarea?: number;
}

/**
 * Modelo de los documentos de la tarea
 *
 * @export
 * @class Documento
 */
export class Documento {
  clasificacion_id: number;
  clasificacion: string;
  codigo_documento: string;
  documentos_detalle: Array<DocumentoDetalle>;
  funciones: Array<FuncionDocumento>;
  id_tipo_documental: number;
  ruta_generacion: string;
  ruta_vista_previa: string;
  tipo_documental: string;
  documento?: number;
  idtarea?: number;
  expediente?: boolean;
  id_expediente_cita?: number;
}
/**
 * Modelo del documento detalle del documento
 *
 * @export
 * @class DocumentoDetalle
 */
export class DocumentoDetalle {
  fecha?: Date;
  folios?: number;
  historial?: Array<HistorialDocumento>;
  id_documento?: number;
  radicado?: string;
  documento_cita?: string;
  id_documento_cita?: number;
}
/**
 * Modelo de las funciones del documento
 *
 * @export
 * @class FuncionDocumento
 */
export class FuncionDocumento {
  id_funcion: number;
  obligatorio: boolean;
  funcion: string;
}
/**
 * Modelo del historial del documento
 *
 * @export
 * @class HistorialDocumento
 */
export class HistorialDocumento {
  id: number;
  nombre: string;
  nombre_archivo: string;
  extension: string;
  version: number;
  revision?: Array<RevisionDocumento>;
  radicado?: boolean;
  tarea_origen?: number;
}
/**
 * Modelo de las revisiones del historial del documento
 *
 * @export
 * @class RevisionDocumento
 */
export class RevisionDocumento {
  id_revision: number;
  id_tarea: number;
  reponsable_id: number;
  nombre_tarea?: string;
  descripcion?: string;
  nombre_responsable?: string;
  apellidos_responsable?: string;
  fecha: string;
  revision: boolean;
  historial_id?: number;
  version?: number;
  opcion: number;
}
/**
 * modelo de informacion de revisiones para el endpoind reviewDocument
 *
 * @export
 * @class Revision
 */
export class Revision {
  descripcion: string;
  documento_historial: number;
  tarea?: number;
  responsable?: number;
  revision: boolean;
  opcion: number;
}

/**
 * Modelo de los documentos asociados de la tarea en automatizacion de procesos
 *
 * @export
 * @class DocumentoAsociarTarea
 */
export class DocumentoAsociarTarea {
  documento: number;
  clasificacion?: string;
  tipo_documental?: string;
  funciones?: Array<FuncionDocumento>;
}

/**
 * Modelo de la consulta de radicados a CITA
 *
 * @export
 * @class RadicadoCita
 */
export class RadicadoCita {
  iddocumento: number;
  radicado: string;
  nombre_archivo: string;
  fecha: string;
}

/**
 * Modelo del documento asociado a la tarea
 *
 * @export
 * @class DocumentoAsociado
 */
export class DocumentoAsociado {
  id_documento: number;
  funciones: Array<FuncionDocumento>;
}

/**
 * Modelo del documento asociado de una tarea en un grupo de tareas asociadas
 *
 * @export
 * @class DocumentoAsociadoGrupo
 * @extends {DocumentoAsociado}
 */
export class DocumentoAsociadoGrupo extends DocumentoAsociado {
  id_tarea: number;
}

/**
 * Modelo de la consulta de los documentos por defecto
 *
 * @export
 * @class DefaultDocument
 */
export class DefaultDocument {
  id: number;
  nombre: string;
  tipo_documental: string;
  subserie: string;
}

/**
 * Modelo de un documento anexado
 *
 * @export
 * @class DocumentoAnexo
 */
export class DocumentoAnexo {
  id?: number;
  nombre: string;
  version: number;
  fecha_registro: string;
}

/**
 * Modelo para las series de documentos
 *
 * @export
 * @class SeriePredeterminada
 */
export class SeriePredeterminada {
  id?: number;
  nombre: string;
  codigo: string;
}

/**
 * Modelo para las subseries de documentos
 *
 * @export
 * @class SubSeriePredeterminada
 */
export class SubSeriePredeterminada {
  id?: number;
  nombre: string;
  codigo: string;
  serie?: SeriePredeterminada;
}

/**
 * Modelo para el tipo documental
 *
 * @export
 * @class TipoDocumentalPredeterminado
 */
export class TipoDocumentalPredeterminado {
  id?: number;
  nombre: string;
  codigo: string;
  subserie?: SubSeriePredeterminada;
  expediente?: Boolean;
}


/**
 * Modelo clasificación para la API
 *
 * @export
 * @class ClasificacionPredeterminadaAPI
 */
export class ClasificacionPredeterminadaAPI {
    id?: number;
    nombre: string;
    tipo_documental: TipoDocumentalPredeterminado;
    rutas?: Rutas[];
    solicitud?: boolean;
}

/**
 * Modelo clasificación
 *
 * @export
 * @class ClasificacionPredeterminada
 * @extends {ClasificacionPredeterminadaAPI}
 */
export class ClasificacionPredeterminada extends ClasificacionPredeterminadaAPI {
    ruta_vista_previa?: boolean;
    ruta_generacion?: boolean;
}


/**
 * Modelo Rutas para los documentos de la clasificación documental
 *
 * @export
 * @class Rutas
 */
export class Rutas {
    id?: number;
    ruta_vista_previa: string;
    ruta_generacion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/documento.model.ts